export default __webpack_public_path__ + "static/media/icon-notification-menu-white.e1265347.svg";